<template>
   <div class="view-group-course-master-details container-fluid"> 
        <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-1Point2Perc cursor-pointer" v-on:click="udpateCloseViewCourseDetailOverlay($event)">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-1Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Version:
                </div>
                <div class="font-size-17px col-md-3 col-lg-3 text-align-left">
                  {{CourseVersionValue}}
                </div>
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Elective Course:
                </div>
                <div class="font-size-17px col-md-3 col-lg-3 text-align-left">
                  {{CourseElectiveValue}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Display Title:
                </div>
                <div class="font-size-17px col-md-3 col-lg-3 text-align-left">
                  {{CourseDisplayTitleValue}}
                </div>
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Display Sub-Title:
                </div>
                <div class="font-size-17px col-md-3 col-lg-3 text-align-left">
                  {{CourseDisplaySubTitleValue}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Master Title:
                </div>
                <div class="font-size-17px col-md-3 col-lg-3 text-align-left">
                  {{CourseTitleValue}}
                </div>
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Master Sub-Title:
                </div>
                <div class="font-size-17px col-md-3 col-lg-3 text-align-left">
                  {{CourseSubTitleValue}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Anonymised R&D's:
                </div>
                <div class="font-size-17px col-md-3 col-lg-3 text-align-left">
                  {{AnonymisedValue}}
                </div>
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                </div>
                <div class="font-size-17px col-md-3 col-lg-3 text-align-left">
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Custom Alert Message:
                </div>
                <div class="font-size-17px col-md-8 col-lg-8 text-align-left">
                  {{CustomAlertMessageValue}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Created TS:
                </div>
                <div class="font-size-17px col-md-3 col-lg-3 text-align-left">
                  {{formatAndShowDate(CourseCreateTSValue)}}
                </div>
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Updated TS:
                </div>
                <div class="font-size-17px col-md-3 col-lg-3 text-align-left">
                  {{formatAndShowDate(CourseUpdatedTSValue)}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <!-- SS: Start Release TS & Expiry Days -->
              <div class="row vertical-align margin-bottom-2Perc" v-if="getSelectedCourseMasterObj.CourseMasterType !== constants.CourseType.RecommendationAssessment">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Release Date:
                </div>
                <div class="font-size-17px col-md-3 col-lg-3 text-align-left">
                  {{formatAndShowDate(CourseReleaseTSValue)}}
                </div>
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Expiry Days:
                </div>
                <div class="font-size-17px col-md-3 col-lg-3 text-align-left">
                  {{ExpiryDaysValue}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc" v-if="getSelectedCourseMasterObj.CourseMasterType !== constants.CourseType.RecommendationAssessment">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  {{completionCriteriaTextLabel}}
                </div>
                <div class="font-size-17px col-md-3 col-lg-3 text-align-left">
                  {{CompletionCriteriaForElectiveValue}}%
                </div>
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                </div>
                <div class="font-size-17px col-md-3 col-lg-3 text-align-left">
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <!-- SS: End Of Release TS & Expiry Days -->
              <!-- AK: Start Completion Criteria -->
              <div class="row vertical-align margin-bottom-2Perc" v-if="getSelectedCourseMasterObj.CourseMasterType !== constants.CourseType.RecommendationAssessment">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Completion Criteria for Certificate:
                </div>
                <div class="font-size-17px col-md-3 col-lg-3 text-align-left">
                  {{CompletionCriteriaValue}}%
                </div>
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Automatically show certificates to Users:
                </div>
                <div class="font-size-17px col-md-3 col-lg-3 text-align-left">
                  {{allowViewCeritificateValue}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <!-- AK: End Of Completion Criteria -->
              <div class="row vertical-align margin-bottom-2Perc" v-if="getSelectedCourseMasterObj.CourseMasterType !== constants.CourseType.RecommendationAssessment">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Enable Certification:
                </div>
                <div class="font-size-17px col-md-3 col-lg-3 text-align-left">
                  {{enableCeritificationValue}}
                </div>
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                 Certificate Title:
                </div>
                <div class="font-size-17px col-md-3 col-lg-3 text-align-left">
                  {{certificateTitleValue}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc" v-if="getSelectedCourseMasterObj.CourseMasterType !== constants.CourseType.RecommendationAssessment">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Certificate Url:
                </div>
                <div class="font-size-17px col-md-3 col-lg-3 text-align-left">
                  <span class="text-decoration-underline" v-if="getCertificateUrlValue !== null"><a class="text-color-blue " :href="getCertificateUrlValue">Download Existing</a></span>
                  <span v-else>NA</span>
                </div>
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                 Certification Date:
                </div>
                <div class="font-size-17px col-md-3 col-lg-3 text-align-left">
                  {{certificationDateValue}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <!-- personalisation -->
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Enable Personalization:
                </div>
                <div class="font-size-17px col-md-3 col-lg-3 text-align-left">
                  {{enablePersonalizationValue}}
                </div>
                <div class="font-size-17px font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px" v-if="selectedCourseMasterObj.IsElective">
                 Allow Self Enrollment:
                </div>
                <div class="font-size-17px col-md-3 col-lg-3 text-align-left" v-if="selectedCourseMasterObj.IsElective">
                  {{allowSelfEnrollmentValue}}
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <!-- personalisation end -->
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="udpateCloseViewCourseDetailOverlay($event)">Done</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
    </div> 
</template>
<script>
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import { constants } from '../utils/constants'
export default {
  props: ['selectedCourseMasterObj'],
  name: 'view-group-course-master-details',
  created () {
    this.setDefaultValues()
  },
  data: function () {
    return {
      constants: constants,
      completionCriteriaTextLabel: 'Completion Criteria for Electives:'
    }
  },
  components: {},
  methods: {
    setDefaultValues: function () {
      this.completionCriteriaTextLabel = this.selectedCourseMasterObj.IsElective ? 'Allow other electives at:' : 'Completion Criteria for Electives:'
    },
    formatAndShowDate: function (date) {
      if (date !== undefined && date !== null && date !== 'null' && date !== '') {
        var dateToPass = date
        if (dateToPass.indexOf('Z') === -1) {
          dateToPass += 'Z'
        }
        return dmAdminUtils.covertUtcToEst(dateToPass)
      } else {
        return 'NA'
      }
    },
    udpateCloseViewCourseDetailOverlay: function (event) {
      this.$emit('closeViewCourse', false)
    }
  },
  computed: {
    getSelectedCourseMasterObj: {
      get: function () {
        return this.selectedCourseMasterObj
      }
    },
    getCertificateObjValue: {
      get: function () {
        return this.selectedCourseMasterObj.Certificate
      }
    },
    getCertificateUrlValue: {
      get: function () {
        if (this.getCertificateObjValue !== undefined && this.getCertificateObjValue !== null && this.getCertificateObjValue !== 'undefined' && this.getCertificateObjValue !== 'null' && this.getCertificateObjValue !== '') {
          return this.getCertificateObjValue.CertificateFile
        } else {
          return null
        }
      }
    },
    getCertificateIdValue: {
      get: function () {
        if (this.getCertificateObjValue !== undefined && this.getCertificateObjValue !== null && this.getCertificateObjValue !== 'undefined' && this.getCertificateObjValue !== 'null' && this.getCertificateObjValue !== '') {
          return this.getCertificateObjValue.CertificateId
        } else {
          return null
        }
      }
    },
    certificationDateValue: {
      get: function () {
        if (this.getCertificateObjValue !== undefined && this.getCertificateObjValue !== null && this.getCertificateObjValue !== 'undefined' && this.getCertificateObjValue !== 'null' && this.getCertificateObjValue !== '') {
          return this.getCertificateObjValue.CertificationDate !== undefined && this.getCertificateObjValue.CertificationDate !== 'undefined' && this.getCertificateObjValue.CertificationDate !== null && this.getCertificateObjValue.CertificationDate !== 'null' && this.getCertificateObjValue.CertificationDate !== '' ? this.getCertificateObjValue.CertificationDate : 'NA'
        } else {
          return 'NA'
        }
      }
    },
    certificateTitleValue: {
      get: function () {
        if (this.getCertificateObjValue !== undefined && this.getCertificateObjValue !== null && this.getCertificateObjValue !== 'undefined' && this.getCertificateObjValue !== 'null' && this.getCertificateObjValue !== '') {
          return this.getCertificateObjValue.CertificateTitle !== undefined && this.getCertificateObjValue.CertificateTitle !== 'undefined' && this.getCertificateObjValue.CertificateTitle !== null && this.getCertificateObjValue.CertificateTitle !== 'null' && this.getCertificateObjValue.CertificateTitle !== '' ? this.getCertificateObjValue.CertificateTitle : 'NA'
        } else {
          return 'NA'
        }
      }
    },
    CourseVersionValue: {
      get: function () {
        if (this.selectedCourseMasterObj.CourseMasterVersion === 'null' || this.selectedCourseMasterObj.CourseMasterVersion === null || this.selectedCourseMasterObj.CourseMasterVersion === undefined) {
          return ''
        }
        return this.selectedCourseMasterObj.CourseMasterVersion
      }
    },
    CourseElectiveValue: {
      get: function () {
        return this.selectedCourseMasterObj.IsElective ? 'Yes' : 'No'
      }
    },
    AnonymisedValue: {
      get: function () {
        return this.selectedCourseMasterObj.Anonymised ? 'Yes' : 'No'
      }
    },
    CourseDisplayTitleValue: {
      get: function () {
        return this.selectedCourseMasterObj.DisplayTitle !== undefined && this.selectedCourseMasterObj.DisplayTitle !== 'undefined' && this.selectedCourseMasterObj.DisplayTitle !== null && this.selectedCourseMasterObj.DisplayTitle !== 'null' && this.selectedCourseMasterObj.DisplayTitle !== '' ? this.selectedCourseMasterObj.DisplayTitle : ''
      }
    },
    CourseDisplaySubTitleValue: {
      get: function () {
        return this.selectedCourseMasterObj.DisplaySubTitle !== undefined && this.selectedCourseMasterObj.DisplaySubTitle !== 'undefined' && this.selectedCourseMasterObj.DisplaySubTitle !== null && this.selectedCourseMasterObj.DisplaySubTitle !== 'null' && this.selectedCourseMasterObj.DisplaySubTitle !== '' ? this.selectedCourseMasterObj.DisplaySubTitle : ''
      }
    },
    CourseTitleValue: {
      get: function () {
        return this.selectedCourseMasterObj.CourseTitle
      }
    },
    CustomAlertMessageValue: {
      get: function () {
        return this.selectedCourseMasterObj.AlertMessage !== undefined && this.selectedCourseMasterObj.AlertMessage !== null && this.selectedCourseMasterObj.AlertMessage !== 'null' && this.selectedCourseMasterObj.AlertMessage !== '' ? this.selectedCourseMasterObj.AlertMessage : null
      }
    },
    CourseSubTitleValue: {
      get: function () {
        return this.selectedCourseMasterObj.CourseSubTitle
      }
    },
    CourseCreateTSValue: {
      get: function () {
        return this.selectedCourseMasterObj.CreatedTS
      }
    },
    CourseUpdatedTSValue: {
      get: function () {
        return this.selectedCourseMasterObj.UpdatedTS
      }
    },
    CourseReleaseTSValue: {
      get: function () {
        // console.log('>>Course Release TS >>' + JSON.stringify(this.selectedCourseMasterObj))
        return this.selectedCourseMasterObj.ReleaseTS
      }
    },
    ExpiryDaysValue: {
      get: function () {
        // console.log('>>ExpiryDaysValue >>' + JSON.stringify(this.selectedCourseMasterObj))
        return this.selectedCourseMasterObj.ExpiryDays !== undefined && this.selectedCourseMasterObj.ExpiryDays !== null && this.selectedCourseMasterObj.ExpiryDays !== 'null' && this.selectedCourseMasterObj.ExpiryDays !== '' ? this.selectedCourseMasterObj.ExpiryDays : 'NA'
      }
    },
    CompletionCriteriaValue: {
      get: function () {
        return this.selectedCourseMasterObj.CompletionRate !== undefined && this.selectedCourseMasterObj.CompletionRate !== null && this.selectedCourseMasterObj.CompletionRate !== 'null' && this.selectedCourseMasterObj.CompletionRate !== '' ? this.selectedCourseMasterObj.CompletionRate : 100
      }
    },
    CompletionCriteriaForElectiveValue: {
      get: function () {
        return this.selectedCourseMasterObj.CompletionCriteriaForElective !== undefined && this.selectedCourseMasterObj.CompletionCriteriaForElective !== null && this.selectedCourseMasterObj.CompletionCriteriaForElective !== 'null' && this.selectedCourseMasterObj.CompletionCriteriaForElective !== '' ? this.selectedCourseMasterObj.CompletionCriteriaForElective : 100
      }
    },
    enableCeritificationValue: {
      get: function () {
        return !this.selectedCourseMasterObj.DisableCertification ? 'Yes' : 'No'
      }
    },
    allowViewCeritificateValue: {
      get: function () {
        return this.selectedCourseMasterObj.AllowView ? 'Yes' : 'No'
      }
    },
    enablePersonalizationValue: {
      get: function () {
        return this.selectedCourseMasterObj.EnablePersonalization ? 'Yes' : 'No'
      }
    },
    allowSelfEnrollmentValue: {
      get: function () {
        return this.selectedCourseMasterObj.AllowSelfEnrollment ? 'Yes' : 'No'
      }
    },
    supportPersonalizationLevelsValue: {
      get: function () {
        var string = this.selectedCourseMasterObj.SupportedPersonalizationLevels
        var indexLevel1 = string.indexOf('1')
        var indexLevel2 = string.indexOf('2')
        var indexLevel3 = string.indexOf('3')
        if (indexLevel1 !== -1 && indexLevel2 !== -1 && indexLevel3 !== -1) {
          return 'Level 1, Level 2, Level 3'
        } else if (indexLevel1 !== -1 && indexLevel2 !== -1) {
          return 'Level 1, Level 2'
        } else if (indexLevel1 !== -1 && indexLevel3 !== -1) {
          return 'Level 1, Level 3'
        } else if (indexLevel2 !== -1 && indexLevel3 !== -1) {
          return 'Level 2, Level 3'
        } else if (indexLevel1 !== -1) {
          return 'Level 1'
        } else if (indexLevel2 !== -1) {
          return 'Level 2'
        } else if (indexLevel3 !== -1) {
          return 'Level 3'
        }
      }
    }
  }
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 10%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}
/*
.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}
*/
.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  /*.overlay a {
    font-size: 20px;
  }*/
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-1Point2Perc {
  margin-right: 1.2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-17px {
  font-size: 17px !important;
}
.text-align-left {
  text-align: left !important;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.course-img-width-height {
  width: 350px;
  height: 150px;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
a:link{
  color: blue !important;
  text-decoration: none !important;
} 
a:visited{
  color: blue !important;
  text-decoration: none !important;
}
a:hover{
  color: blue !important;
  text-decoration: none !important;
}
a:active{
  color: blue !important;
  text-decoration: none !important;
}
a {
  color: blue !important;
  text-decoration: none !important;
}
.text-color-blue {
  color: blue;
}
.text-decoration-underline {
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/ViewGroupCourseMasterOverlay.vue